'use strict';

var React = require('react');
var reactTable = require('@tanstack/react-table');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const Cell = (props) => {
    const { cell, className, ...restProps } = props;
    return (React__namespace.createElement("td", { className: "h-p-16", style: { width: `${cell.column.getSize()}px` }, ...restProps }, reactTable.flexRender(cell.column.columnDef.cell, cell.getContext())));
};

exports.Cell = Cell;
//# sourceMappingURL=Cell.js.map
